module.exports = __webpack_public_path__ + "img/mrclogo.35fcd8e9.svg";